import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.product.barchart');
import { Input, OnChanges, OnDestroy, ElementRef } from '@angular/core';
import { Chart } from 'chart.js/auto';

interface ProductItem {
    grade: number;
    quantity: number;
    plate: number;
    weight: number;
    start: string;
    end: string;
}

@Component({
    selector: 'wiz-component-product-barchart',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.product.barchart/view.scss */
:host {
  display: block;
  width: 100%;
  min-width: 0;
}`],
})
export class ComponentProductBarchartComponent implements OnChanges, OnDestroy {

    @Input() data: ProductItem[] | null = null;

    public display: any = {};
    public isEmpty: boolean = true;

    private chart?: Chart;

    private gradeMap = '왕란,특란,대란,중란,소란,경란,파란,혈란,오란,등외'.split(',');

    constructor(@Inject( ElementRef) private el: ElementRef) {}

    ngOnDestroy() {
        this.chart?.destroy();
    }

    ngOnChanges() {
        if (!this.data?.length) {
            this.isEmpty = true;
            return;
        }

        this.isEmpty = false;

        let labels: string[] = [];
        let values: number[] = [];

        this.display.quantity = 0;
        this.display.plate = 0;
        this.display.weight = 0;

        for (const item of this.data) {
            labels.push(this.gradeMap[item.grade - 1]);
            values.push(item.quantity);

            this.display.start = item.start;
            this.display.end = item.end;

            this.display.quantity += item.quantity;
            this.display.plate += item.plate;
            this.display.weight += item.weight;
        }

        this.display.average_weight =
            this.display.quantity > 0
                ? this.display.weight / this.display.quantity * 1000
                : 0;

        setTimeout(() => {
            const canvas = this.el.nativeElement.querySelector('canvas') as HTMLCanvasElement;
            if (!canvas) return;

            this.chart?.destroy();

            this.chart = new Chart(canvas.getContext('2d')!, {
                type: 'bar',
                data: {
                    labels,
                    datasets: [{
                        label: '생산수량',
                        data: values,
                        backgroundColor: [
                            'rgba(246, 146, 50, 0.85)',
                            'rgba(16, 185, 129, 0.85)',
                            'rgba(56, 189, 248, 0.85)',
                            'rgba(139, 92, 246, 0.85)',
                            'rgba(236, 72, 153, 0.85)',
                            'rgba(234, 179, 8, 0.85)',
                            'rgba(20, 184, 166, 0.85)',
                            'rgba(239, 68, 68, 0.85)',
                            'rgba(99, 102, 241, 0.85)',
                            'rgba(156, 163, 175, 0.85)'
                        ],
                        borderRadius: 6,
                        borderSkipped: false
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            backgroundColor: '#141414',
                            cornerRadius: 8,
                            padding: 10
                        }
                    },
                    scales: {
                        x: {
                            grid: { display: false },
                            ticks: { font: { size: 12 }, color: '#6b7280' }
                        },
                        y: {
                            beginAtZero: true,
                            grid: { color: 'rgba(107,114,128,0.08)' },
                            ticks: { font: { size: 12 }, color: '#6b7280' }
                        }
                    }
                }
            });
        }, 0);
    }
}

export default ComponentProductBarchartComponent;